<template>
	<v-container fluid >
		<v-toolbar>
			<v-toolbar-title>{{ title }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<!-- <v-btn icon @click="search.brand.visible = !search.brand.visible">
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
			<v-btn icon>
				<v-icon>mdi-plus</v-icon>
			</v-btn> -->
		</v-toolbar>
		<v-row class="mt-2">
			<v-col cols="12" md="3">
				<v-card :loading="loading.category">
					<v-toolbar flat>
						<v-toolbar-title>Категорії</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<v-list>
							<v-list-item-group v-model="category" active-class="indigo--text">
								<v-list-item v-for="(item, index) in categories" :key="index" @click="onCategory(item)">
									<v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<!-- <v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn> -->
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon v-bind="attrs" v-on="on">
													<v-icon>mdi-dots-vertical</v-icon>
												</v-btn>
											</template>
											<v-list>
												<!-- <v-list-item @click="onIdentification(null, 'number')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-n-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За номером</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												<v-list-item @click="onIdentification(null, 'vin')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-v-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За VIN-кодом</v-list-item-title>
													</v-list-item-content>
												</v-list-item> -->
											</v-list>
										</v-menu>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
				<v-card class="my-1" :loading="loading.brand">
					<v-toolbar flat :extended="search.brand.visible">
						<v-toolbar-title>Марки</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="search.brand.visible = !search.brand.visible">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>

						<template v-slot:extension v-if="search.brand.visible">
							<v-text-field v-model="search.brand.text"
								hide-details
								single-line
								clearable
							></v-text-field>
							<!-- prepend-icon="mdi-magnify" -->
						</template>
					</v-toolbar>
					<!-- <v-card-text style="height: 300px; overflow-y: auto;"> -->
					<!-- <v-card-text style="overflow-y: auto;"> -->
					<v-card-text>
						<v-list>
							<v-list-item-group v-model="brand" active-class="green--text">
								<v-list-item v-for="(item, index) in filteredBrands" :key="index" @click="onBrand(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
									</v-list-item-content>

									<v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card :loading="loading.model">
					<!-- <v-toolbar flat>
						<v-toolbar-title>Моделі</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-toolbar> -->
					<v-toolbar flat :extended="search.model.visible">
						<v-toolbar-title>Моделі</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="search.model.visible = !search.model.visible">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>

						<template v-slot:extension v-if="search.model.visible">
							<v-text-field v-model="search.model.text"
								hide-details
								single-line
								clearable
							></v-text-field>
							<!-- prepend-icon="mdi-magnify" -->
						</template>
					</v-toolbar>
					<v-card-text>
						<v-list>
							<v-list-item-group v-model="model" active-class="pink--text">
								<v-list-item v-for="(item, index) in filteredModels" :key="index" @click="onModel(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
									</v-list-item-content>

									<v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card :loading="loading.generation">
					<v-toolbar flat>
						<v-toolbar-title>Покоління</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<v-list>
							<v-list-item-group v-model="generation" active-class="pink--text">
								<v-list-item v-for="(item, index) in generations" :key="index" @click="onGeneration(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
									</v-list-item-content>

									<v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card :loading="loading.modification">
					<v-toolbar flat>
						<v-toolbar-title>Модифікація</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<v-list>
							<v-list-item-group v-model="modification" active-class="pink--text">
								<v-list-item v-for="(item, index) in modifications" :key="index">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
									</v-list-item-content>

									<v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay> -->
	</v-container>
</template>

<script>
import axios from 'axios'
//import mixin from './mixin/main'
//import mixin from './mixin/parameters'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'

//import zDetail from '@/views/dialogs/details/VehiclePark'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'VehicleBrandModel',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail, zDialogEstimate,
		zConfirmDelete,
	},
	data: () => ({
		title: 'Марки та моделі',
		subtitle: 'Визначення середньої ціни із застосуванням технології AI',
		icon: 'mdi-car',
		loading: false,

		search: {
			brand: {
				visible: false,
				text: '',
			},
			model: {
				visible: false,
				text: '',
			},
			generation: {
				visible: false,
				text: '',
			},
			modification: {
				visible: false,
				text: '',
			},
		},

		loading: {
			category: false,
			brand: false,
			model: false,
			generation: false,
			modification: false,
		},

		category: {},
		brand: {},
		model: {},
		generation: {},
		modification: {},

		categories: [],
		brands: [],
		models: [],
		generations: [],
		modifications: [],

		/* headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true},
			{ text: 'Авто', value: 'vehicles.length', sortable: true},
			{ text: 'Оцінки', value: 'estimates.length', sortable: true},
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		page: 1,
		pageCount: 2,
		itemsPerPage: 15, */

		/* snackbar: {
			visible: false,
			text: null
		}, */
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),

		filteredBrands() {
			if (!this.search.brand.text) {
				return this.brands;
			}
			return this.brands.filter(item =>
				item.name.toLowerCase().includes(this.search.brand.text.toLowerCase())
			);
		},

		filteredModels() {
			if (!this.search.model.text) {
				return this.models;
			}
			return this.models.filter(item =>
				item.name.toLowerCase().includes(this.search.model.text.toLowerCase())
			);
		},
	},

	created () {
		this.loadCategories()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		/* onRefresh() {
			this.loading = true
			return this.search().finally(() => (this.loading = false));
		}, */

		/* clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			//this.$set(this.item, 'model', null)
			//this.setModels()
			
			this.clearGeneration()
		},

		clearGeneration () {
			this.$set(this.item, 'generation', null)
			this.setGenerations()
			
			this.clearModification()
		},

		clearYearProd() {
			this.$set(this.item, 'yearProd', null)
			this.minYear = 1900
			this.maxYear = (new Date()).getFullYear()
		},

		clearModification () {
			this.$set(this.item, 'modification', null)
			this.setModifications()
		}, */

		// Завантаження категорій
		loadCategories() {
			var that = this
			this.loading.category = true
			axios.get('/vehicle/category').then(response => {
				//console.log(that.$options.name, 'loadCategories','response.data', response.data)
				//that.setCategories(response.data.filter((element) => ['CAR','TRUCK'].includes(element.code)))
				//that.categories = response.data
				that.categories = response.data.filter((element) => ['CAR','TRUCK'].includes(element.code))
				that.brands = []
				that.models = []
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.category = false));
		},

		// Завантаження брендів
		loadBrands(category) {
			var that = this
			this.loading.brand = true
			axios.get(`/vehicle/category/${category.id}/brand`).then(response => {
				//console.log(that.$options.name, 'GetBrands','response.data', response.data)
				that.brands = response.data
				that.models = []
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.brand = false));
		},

		// Завантаження моделей
		loadModels(category, brand) {
			//console.log(this.$options.name, 'loadModels','category', category)

			var that = this
			this.loading.model = true
			axios.get(`/vehicle/category/${category.id}/brand/${brand.id}/models`).then(response => {
				//console.log(that.$options.name, 'GetdModels','response.data', response.data)
				that.models = response.data
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.model = false));
		},

		// Завантаження поколінь
		loadGenerations(model) {
			var that = this
			this.loading.generation = true
			axios.get(`/vehicle/model/${model.id}/generation`).then(response => {
				//console.log(that.$options.name, 'GetBrands','response.data', response.data)
				that.generations = response.data
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.generation = false));
		},

		// Завантаження модифікацій
		loadModifications(generation) {
			var that = this
			this.loading.modification = true
			axios.get(`/vehicle/generation/${generation.id}/modification`).then(response => {
				//console.log(that.$options.name, 'GetBrands','response.data', response.data)
				that.modifications = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.modification = false));
		},


		onCategory(item) {
			//console.log(this.$options.name, 'onCategory','item', item)
			//this.category = item
			this.loadBrands(item);
		},

		onBrand(item) {
			//console.log(this.$options.name, 'onBrand','item', item)
			//console.log(this.$options.name, 'onBrand','category', this.category)
			this.loadModels(this.categories[this.category], item);
		},

		onModel(item) {
			//console.log(this.$options.name, 'onModel','item', item)
			this.loadGenerations(item);
		},

		onGeneration(item) {
			//console.log(this.$options.name, 'onGeneration','item', item)
			this.loadModifications(item);
		},

		/* onModification(item) {
			console.log(this.$options.name, 'onModification','item', item)
			loadBrands(item);
		}, */
	},
}
</script>